import { createAsyncThunk } from "@reduxjs/toolkit";
import { PostVouchersPromocodesBody } from "api/api/vouchersApi/types";
import { VouchersAPI } from "api/api/vouchersApi/vouchersApi";
import axios from "axios";

export const postVouchersPromocodes = createAsyncThunk<
  void,
  PostVouchersPromocodesBody
>("vouchers/postVouchersPromocodes", async (body, { rejectWithValue }) => {
  try {
    await VouchersAPI.postVouchersPromocodes(body);
  } catch (error: unknown) {
    if (axios.isAxiosError(error)) {
      console.error(
        "Error while creating vouchers promocodes",
        error.response?.data
      );
      return rejectWithValue(error.response?.data || "Unknown error");
    } else {
      console.error("Error while creating vouchers promocodes", error);
      return rejectWithValue(
        "Что-то пошло не так... Попробуйте обновить страницу"
      );
    }
  }
});
